import { FC } from 'react'

import type { PartnerSummaryBlockProps } from 'clickNgo/entities/partner/ui/partnerSummaryBlock'
import { Translation } from 'cng-common/features/translations/components/translation'
import { ModalDialog } from 'core-components/library/modalDialog'
import { NetworkDebugSource } from 'shared/lib/networkDebug'

import type { AcknowledgmentCommitmentItem, AcknowledgmentUpdatedPayload } from '../model/types'
import { ACKNOWLEDGMENT_STATUS_DIALOG_TRANSLATION_KEYS } from '../translations'

import type { AcknowledgmentBlockedAction } from './AcknowledgmentBlockedBanner'
import { AcknowledgmentStatusDialogContent } from './AcknowledgmentStatusDialogContent'

import styles from './AcknowledgmentStatusDialog.module.scss'

type AcknowledgmentStatusDialogProps = {
  show: boolean
  onClose: () => void
  partnerId: string
  fYear: number
  offering: string
  offeringLabel?: string
  onSigned?: (item: AcknowledgmentCommitmentItem) => void
  onNotified?: (item: AcknowledgmentCommitmentItem) => void
  onUpdated?: (payload: AcknowledgmentUpdatedPayload) => void | Promise<void>
  partnerSummary?: PartnerSummaryBlockProps
  blockedAction?: AcknowledgmentBlockedAction | null
}

export const AcknowledgmentStatusDialog: FC<AcknowledgmentStatusDialogProps> = ({
  show,
  onClose,
  offering,
  offeringLabel,
  fYear,
  ...props
}) => (
  <NetworkDebugSource name="Acknowledgment window">
    <ModalDialog
      closeOnOutsideClick={false}
      show={show}
      onClose={onClose}
      size="lg"
      header={() => (
        <div className={styles.dialogHeader}>
          <div className={styles.title}>
            <Translation
              span
              text={ACKNOWLEDGMENT_STATUS_DIALOG_TRANSLATION_KEYS.dialog.title}
              replaceParams={[
                { key: '{offering}', value: offeringLabel ?? offering },
                { key: '{fYear}', value: String(fYear) },
              ]}
            />
          </div>
        </div>
      )}
      classes={{
        window: styles.window,
        body: styles.body,
      }}
      content={AcknowledgmentStatusDialogContent}
      contentProps={{
        ...props,
        offering,
        fYear,
        onClose,
      }}
    />
  </NetworkDebugSource>
)
